import { formatDistance } from "@/components/common/settings-context/distance-unit-utils";
import { DistanceUnitTypes } from "@faro-lotv/foundation";

export enum UnitType {
  /** A length, given in meters. */
  length = "length",

  /** A fractional value between 0 and 1. */
  fraction = "fraction",
}

/** Number of decimals to display. */
const DECIMALS = 1;

/**
 * @param value The value in the base unit (meter for lengths).
 * @param unit The unit the value is given in.
 * @param distanceUnit The user's preferred distance unit type.
 *        However, we automatically use small units since this is very likely desired for the
 *        registration report.
 *        Like in SCENE, we also use an additional decimal digit for millimeters.
 * @returns A string representing the unit value.
 */
export function displayUnitValue(
  value: number | undefined | null,
  unit: UnitType,
  distanceUnit: DistanceUnitTypes = DistanceUnitTypes.millimeters,
): string {
  if (value === undefined || value === null) return "--";
  if (value === Number.MAX_VALUE) return "Infinity";

  switch (unit) {
    case UnitType.length:
      return formatDistance(value, distanceUnit, {
        useSmallUnits: true,
        useIncreasedMMPrecision: true,
      });
    case UnitType.fraction:
      return displayFraction(value);
  }
}

/**
 *
 * @param value The fraction to display. A value between 0 and 1.
 * @returns A string representing the fraction.
 */
function displayFraction(value: number): string {
  const percentage = value * 100;
  return `${percentage.toFixed(DECIMALS)}%`;
}
